<div id="breadcrumb" class="bg-secondary py-2">
  <div class="container py-2 py-lg-3">
    <div class="row align-items-center text-center text-lg-start">
      <!-- Título -->
      <div class="col-12 col-lg-6 order-2 order-lg-1 mb-2 mb-lg-0">
        <h1 class="h3 mb-0">{{ title }}</h1>
      </div>

      <!-- Breadcrumb -->
      <div class="col-12 col-lg-6 order-1 order-lg-2 mb-2 mb-lg-0">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb flex-wrap justify-content-center justify-content-lg-end mb-0">
            @for(item of breadcrumbItems;track $index){
              <ng-container>
                <li
                  class="breadcrumb-item"
                  [ngClass]="{'active': item.active == true}"
                  [attr.aria-current]="item.active ? 'page' : null">
                  @if(item.active){
                    {{ item.label }}
                  }@else{
                    <a routerLink="{{ item.link }}">{{ item.label }}</a>
                  }
                </li>
              </ng-container>
            }
          </ol>
        </nav>
      </div>
    </div>
  </div>
</div>
